import m from "json-stable-stringify";
import { stripIndent as E } from "common-tags";
import { customAlphabet as y } from "nanoid";
const u = (e) => m(e, {
  replacer: (t, r) => {
    if (typeof r == "bigint") return Number(r);
    if (typeof r == "string") {
      const s = r.replaceAll('"', "");
      if (s === "") return r;
      const n = Number(s);
      if (!isNaN(n))
        return n;
    }
    return r;
  }
}) || "", b = {
  text: async (e, t) => ({
    resourceId: e.resourceId,
    name: e.name,
    description: e.description,
    originalFileName: e.originalFileName,
    // todo: limit very large files
    text: await (t == null ? void 0 : t.text())
  }),
  code: async (e, t) => ({
    resourceId: e.resourceId,
    name: e.name,
    description: e.description,
    language: e.language,
    code: await (t == null ? void 0 : t.text())
  }),
  connector: async (e) => ({
    connectorId: e.resourceId,
    name: e.name,
    description: e.description,
    connectorType: e.connectorType,
    dataModel: e.semantic_model
  }),
  json: async (e) => ({
    resourceId: e.resourceId,
    name: e.name,
    description: e.description,
    tableSchema: e.schema,
    originalFileName: e.originalFileName
  }),
  table: async (e) => {
    var t;
    return {
      resourceId: e.resourceId,
      tableName: (t = e.schema) == null ? void 0 : t.tableName,
      tableSchema: e.schema,
      originalFileName: e.originalFileName
    };
  },
  visualization: async (e, t) => ({
    visualizationId: e.resourceId,
    name: e.name,
    description: e.description,
    data: await (t == null ? void 0 : t.text())
  }),
  // TODO: drop this resource type?
  schema: async (e) => ({}),
  metric: async (e) => ({
    metricId: e.resourceId,
    name: e.name,
    description: e.description
  }),
  secret: async (e) => ({
    secretId: e.resourceId,
    name: e.name,
    description: e.description
  })
}, w = (e, t) => {
  const r = JSON.parse(t);
  return (!r.local_db || typeof r.local_db == "string") && (r.local_db = {}), r.local_db[e.tableName] = e, u(r);
}, h = (e) => e === "table" ? "local_db" : e + "s", T = async (e) => {
  const r = (await Promise.all(
    e.map(async (s) => {
      const n = b[s.resourceType], o = await n(s);
      return {
        resource: s,
        context: o
      };
    })
  )).reduce(
    (s, { resource: n, context: o }) => {
      const a = h(n.resourceType);
      return {
        ...s,
        [a]: {
          ...s[a] || {},
          [n.resourceId]: o
        }
      };
    },
    {}
  );
  return r.local_db || (r.local_db = "The local DB is empty"), r;
}, g = async (e, t) => {
  if (e.resourceType !== "table")
    throw new Error(`Unsupported resource type: ${e.resourceType}`);
  const r = await t.storage.loadRawFile(e.resourceId), s = await t.db.createTableFromFile(e.resourceId, r);
  if (s.error || !s.success)
    throw new Error(`Failed to create table for resource ${e.resourceId}: ${s.error}`);
  const n = await t.db.describeTable(s.success.tableName || "");
  if (n.error || !n.success)
    throw new Error(`Error describing table for resource ${e.resourceId}: ${n.error}`);
  return { resourceId: e.resourceId, description: n.success };
}, x = async (e, t) => {
  const r = {}, n = e.filter((a) => a.resourceType === "table").map(
    (a) => g(a, t).then(({ resourceId: c, description: i }) => ({
      resourceId: c,
      result: { success: { schema: i } }
    })).catch((c) => ({
      resourceId: a.resourceId,
      result: { success: null, error: c.message || String(c) }
    }))
  ), o = await Promise.all(n);
  for (const { resourceId: a, result: c } of o)
    r[a] = c;
  return await t.db.clearTables(), r;
};
function f(e) {
  if (Array.isArray(e))
    return {
      type: "array",
      items: e.length > 0 ? f(e[0]) : { type: "any" }
    };
  if (typeof e == "object" && e !== null) {
    const t = {};
    for (const r in e)
      e.hasOwnProperty(r) && (t[r] = f(e[r]));
    return {
      type: "object",
      properties: t
    };
  } else return typeof e == "string" ? { type: "string" } : typeof e == "number" ? { type: "number" } : typeof e == "boolean" ? { type: "boolean" } : e === null ? { type: "null" } : { type: "any" };
}
const C = (e) => {
  let t = 2166136261;
  for (let r = 0; r < e.length; r++)
    t ^= e.charCodeAt(r), t = Math.imul(t, 16777619);
  return (t >>> 0).toString(16);
};
function _(e) {
  if (e.type !== "array")
    return !1;
  const t = e.items;
  if (!t || t.type !== "object" || !t.properties || typeof t.properties != "object")
    return !1;
  const r = ["string", "number", "integer", "boolean", "null"];
  for (const s in t.properties)
    if (Object.prototype.hasOwnProperty.call(t.properties, s)) {
      const n = t.properties[s];
      if (typeof n.type == "string") {
        if (!r.includes(n.type))
          return !1;
      } else if (Array.isArray(n.type)) {
        if (!n.type.every((o) => r.includes(o)))
          return !1;
      } else
        return !1;
    }
  return !0;
}
function F(e) {
  if (e = e.trim(), e.length === 0)
    return null;
  try {
    return JSON.parse(e);
  } catch {
  }
  const t = e[0], r = t === "{" ? "}" : t === "[" ? "]" : "";
  function s(o, a, c) {
    let i = 0, l = !1, d = !1;
    for (const p of o) {
      if (d) {
        d = !1;
        continue;
      }
      if (p === "\\") {
        d = !0;
        continue;
      }
      if (p === '"') {
        l = !l;
        continue;
      }
      l || (p === a ? i++ : p === c && i--);
    }
    return i > 0 ? i : 0;
  }
  const n = 10;
  for (let o = e.length - 1; o > 0; o--) {
    const a = e.substring(0, o).trim();
    try {
      return JSON.parse(a);
    } catch {
    }
    if (r) {
      const c = s(a, t, r);
      if (c > 0 && c <= n) {
        const i = a + r.repeat(c);
        try {
          return JSON.parse(i);
        } catch {
        }
      }
      for (let i = c + 1; i <= n; i++) {
        const l = a + r.repeat(i);
        try {
          return JSON.parse(l);
        } catch {
        }
      }
    }
  }
  return null;
}
const O = (e) => {
  try {
    return JSON.parse(e);
  } catch {
    return e;
  }
}, I = y("1234567890abcdefghijklmz", 6), R = (e = "r") => `${e}${I()}`;
export {
  w as appendToLocalDBContext,
  x as describeResources,
  T as getQueryContext,
  f as getSchema,
  C as hashString,
  _ as isTabular,
  F as parseJSONStream,
  E as prompt,
  b as resourceContext,
  O as safeParse,
  u as safeStringify,
  R as shortUID
};
//# sourceMappingURL=index.js.map
